import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import StepViewer from './StepViewer';
import StepEditor from './StepEditor';
import { useUpdatePropertyMutation } from '../store/docApi';

export default function Instructions({ item = {} }) {
  const [isEditing, setIsEditing] = useState(false);
  const [updateProperty] = useUpdatePropertyMutation();
  const steps = item?.steps || [];
  const parts = item?.parts || [];

  const handleSave = async (updatedSteps) => {
    try {
      await updateProperty({
        label: item.label,
        pk: item.pk,
        id: item.id,
        name: 'steps',
        value: updatedSteps
      });
      setIsEditing(false);
    } catch (error) {
      console.error('Error saving steps:', error);
    }
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">
          Instructions
        </Typography>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? 'View' : 'Edit'}
        </Button>
      </Box>
      {isEditing ? (
        <StepEditor 
          steps={steps} 
          onSave={handleSave}
          parts={parts}
        />
      ) : (
        steps.length > 0 && <StepViewer steps={steps} showVerbal={true} parts={parts} itemId={item.id} itemPk={item.pk} />
      )}
    </Box>
  );
} 